/* Home 2609 – Three Doors
   1023px and below the cards scroll sideways. The dots follow the card in the middle,
   in the order the cards appear on screen (a Featured card moves to the front with CSS order). */
(function () {
  function init(root) {
    if (!root || root.h2609Ready) return;
    root.h2609Ready = true;
    var track = root.querySelector('.h2609-doors-track');
    var dots = root.querySelectorAll('.h2609-doors-dots span');
    if (!track || !dots.length) return;

    function update() {
      var cards = Array.prototype.slice.call(track.children).sort(function (a, b) { return a.offsetLeft - b.offsetLeft; });
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (el, i) {
        var mid = el.offsetLeft - track.offsetLeft + el.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === best);
    }

    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-h2609-doors]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-h2609-doors] .h2609-door') : null;
    if (!card) return;
    var track = card.parentElement;
    if (track.scrollWidth > track.clientWidth) {
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: 'auto' });
    }
  });
})();
